import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

const includes = [
  "organization",
  "issuer",
  "items",
  "items.purchasesInvoiceable",
  "items.purchasesInvoiceable.categories",
  "allowedLocations",
  "purchasesOrder",
  "destinationWarehouse",
  "items.taxGroups",
  "items.unitOfMeasureUnit",
  "serviceCenter",
  "establishment",
  "cafeteria",
  "paymentTerm",
  "canceledBy",
];

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/purchases-invoices`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/purchases-invoices/${id}?include=${includes.join(",")}`,
      options
    )
    .then((response) => {
      let invoice = jsona.deserialize(response.data);
      delete invoice.links;
      return invoice;
    });
}

function add(invoice) {
  const payload = jsona.serialize({
    stuff: invoice,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/purchases-invoices?include=${includes.join(",")}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(invoice) {
  const payload = jsona.serialize({
    stuff: invoice,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(
      `${url}/purchases-invoices/${invoice.id}?include=${includes.join(",")}`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/purchases-invoices/${id}`, options);
}

function validate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/purchases-invoices/${id}/validate?include=${includes.join(",")}`,
      options
    )
    .then((response) => {
      let invoice = jsona.deserialize(response.data);
      delete invoice.links;
      return invoice;
    });
}

function cancel(payload) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  const id = payload?.id;
  const body = {
    cancellation_reason: payload?.cancellation_reason ?? "",
    send_mail: !!payload?.send_mail,
    recipient_email: payload?.recipient_email ?? null,
  };

  return axios
    .post(
      `${url}/purchases-invoices/${id}/cancel?include=${includes.join(",")}`,
      body,
      options
    )
    .then((response) => {
      let invoice = jsona.deserialize(response.data);
      delete invoice.links;
      return invoice;
    });
}

function print(id) {
  const options = {
    headers: {},
    responseType: "blob",
  };
  return axios.get(`${url}/purchases-invoices/${id}/print`, options);
}

function paymentPrint(id) {
  const options = {
    headers: {},
    responseType: "blob",
  };
  return axios.get(`${url}/purchases-invoices/${id}/payments/print`, options);
}

function sendPaymentMail(data) {
  const payload = {
    ...data,
    id: undefined,
  };

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/purchases-invoices/${data?.id}/payments/send-mail`,
      payload,
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function sendMail(data) {
  const payload = {
    ...data,
    id: undefined,
  };

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/purchases-invoices/${data?.id}/send-mail`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function updateInvoicingDate({ id, invoicing_date }) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(
      `${url}/purchases-invoices/${id}/invoicing-date`,
      { invoicing_date },
      options
    )
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function recalculate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/purchases-invoices/${id}/recalculate?include=${includes.join(",")}`,
      options
    )
    .then((response) => {
      let invoice = jsona.deserialize(response.data);
      delete invoice.links;
      return invoice;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  validate,
  cancel,
  print,
  paymentPrint,
  sendMail,
  sendPaymentMail,
  updateInvoicingDate,
  recalculate,
};
